module.exports = __webpack_public_path__ + "static/media/tire-image.cfff9e7c.jpg";